import { userSaveFavoriteBatchCheck } from '~/server/common'

type Callback = (arg: any) => any
interface likeType {
  dataId?: number // sortId==6（新房户型）：此值为楼盘ID；sortId==31（小区户型）：此值为小区ID；其余情况均不需要传。
  numberId: number[] // 二手房房源ID、租房房源ID、小区ID、资讯ID、新房楼盘ID、新房户型ID、家装ID、新房房源ID、小区户型ID、建材公司ID、建材产品ID、装修案例ID
  sortId: number // 收藏类别ID --> 1：二手房；2：租房；3：小区；4：资讯；5：新房楼盘；6：新房户型；7：家装；8：新房房源；31：小区户型；71：建材公司；72：建材产品；73：装修案例
  cb?: Callback // 回调接口
}

/**
 * 发请求校验是否需要收藏
 */
export default async function userSaveCheck(likeParams: likeType) {
  const cityInfoStore = useCityInfoStore()
  const { dataId, numberId, sortId, cb } = likeParams
  const params = numberId.map((i) => {
    return {
      cityId: cityInfoStore.city,
      numberId: i,
      sortId,
      dataId,
    }
  })
  const res = await userSaveFavoriteBatchCheck(params)
  const { code, dataBody = {} as any } = res
  // 未登录的情况全返回0
  if (code !== 0) {
    const result = {
      code: 0,
      dataBody: numberId.reduce((acc, key) => {
        acc[key] = 0
        return acc
      }, {}),
    }
    if (cb) {
      cb(result)
    }
    return result
  }
  else {
    //  跟据请求结果执行回调
    if (cb) {
      cb(res)
    }
    return { code, dataBody }
  }
}
